import { render } from "./DangerTriangle.vue?vue&type=template&id=0c7106ea"
import script from "./DangerTriangle.vue?vue&type=script&lang=js"
export * from "./DangerTriangle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__